var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _path2, _rect9, _rect10, _rect11, _rect12, _path3, _path4, _circle, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 69,
    viewBox: "0 0 73 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 40,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 48,
    height: 4,
    rx: 1,
    fill: "#9A5DB8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 10,
    width: 12,
    height: 4,
    rx: 1,
    fill: "#F3EFF8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 17,
    width: 12,
    height: 4,
    rx: 1,
    fill: "#F3EFF8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 24,
    width: 12,
    height: 4,
    rx: 1,
    fill: "#F3EFF8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 31,
    width: 12,
    height: 4,
    rx: 1,
    fill: "#F3EFF8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 10,
    width: 12,
    height: 4,
    rx: 1,
    fill: "#F3EFF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18C19.5 17.4477 19.9477 17 20.5 17H31.5L25.2493 17.4808C25.0856 17.4934 24.9276 17.5461 24.7891 17.6342L21.0369 20.022C20.3712 20.4456 19.5 19.9674 19.5 19.1783V18Z",
    fill: "#F3EFF8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 10,
    width: 12,
    height: 4,
    rx: 1,
    fill: "#F3EFF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0525 18.7593C40.3476 18.1551 40.7749 17 41.7033 17H46C46.5523 17 47 17.4477 47 18V19.7534C47 20.3931 46.4076 20.8684 45.7831 20.7296L42.744 20.0542C42.5838 20.0186 42.4348 19.9441 42.3102 19.8373L41.0525 18.7593Z",
    fill: "#F3EFF8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 30,
    width: 15,
    height: 5,
    rx: 1,
    fill: "#9A5DB8",
    fillOpacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 23,
    width: 14,
    height: 5,
    rx: 1,
    fill: "#9A5DB8",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 23,
    width: 10,
    height: 5,
    rx: 1,
    fill: "#9A5DB8",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 30,
    width: 10,
    height: 5,
    rx: 1,
    fill: "#9A5DB8",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2087 16.4855C23.3894 16.1843 23.7149 16 24.0662 16H31.5C32.0523 16 32.5 16.4477 32.5 17V20C32.5 20.5523 32.0523 21 31.5 21H22.2662C21.4889 21 21.0088 20.152 21.4087 19.4855L23.2087 16.4855Z",
    fill: "#9A5DB8",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 17.2808C35.5 16.6302 36.1114 16.1528 36.7425 16.3106L41.2313 17.4328C41.4071 17.4768 41.5677 17.5677 41.6959 17.6959L43.2929 19.2929C43.9229 19.9229 43.4767 21 42.5858 21H36.5C35.9477 21 35.5 20.5523 35.5 20V17.2808Z",
    fill: "#9A5DB8",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5962,
    cy: 28.5962,
    r: 13.7708,
    transform: "rotate(135 32.5962 28.5962)",
    stroke: "#873CAA",
    strokeWidth: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8262,
    y: 33.7792,
    width: 29.3199,
    height: 7.32998,
    rx: 3.66499,
    transform: "rotate(45 43.8262 33.7792)",
    fill: "#873CAA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44.69,
    y: 32.9154,
    width: 8.55164,
    height: 9.7733,
    rx: 2,
    transform: "rotate(45 44.69 32.9154)",
    fill: "#9A5DB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.32861d2377b40b537265c7053aa0b6cc.svg";
export { ForwardRef as ReactComponent };